import 'view/css/unit-service.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { useState, useEffect} from 'react';
import API from 'service/api';
import { Data } from 'service/util';

import Protected from 'component/Protected';
import Loading from 'component/Loading';
import NoData from 'component/NoData';
import ModalScreen from 'component/ModalScreen';
import PopMessage from 'component/pop-msg/PopMessage';

import UnitServiceRow from 'component/unit-service/UnitServiceRow';

const UnitServiceModal = ({service, mode}) =>
{
  const [srv_grp,  setGroup      ] = useState(service?.srv_grp   || 1   );
  const [srv_name, setName       ] = useState(service?.srv_name  || ''  );
  const [srv_desc, setDescription] = useState(service?.srv_desc  || ''  );
  const [srv_img,  setImage      ] = useState(service?.srv_img   || null);
  const [price,    setPrice      ] = useState(service?.price     || 0   );

  const submit = () => {
    let dto = {
      id: service?.id || null,
      srv_grp, srv_name, srv_desc,
      srv_img, price
    };

    let query = !service
      ? API.addUnitService(dto)
      : API.editUnitService(dto);

    query.then(resp => {
      if (!resp.success) {
        PopMessage.show('Database operation failed', '操作失敗', 'danger');
      } else {
        PopMessage.show('Success', '成功', 'success');
        window.location.reload();
      }
    });

  }

  return (
    <div>
      <div>
        <label className="field">
          <strong>分類</strong>
          <select value={srv_grp} onChange={e=>setGroup(parseInt(e.target.value,10))}>
            { Data.serviceGroup.map(g =>
              <option key={g.id} value={g.id}>{g.id} - {g.grp_name}</option>
            )}
          </select>
        </label>
        <label className="field">
          <strong>服務/商品名稱</strong>
          <input value={srv_name} onChange={e=>setName(e.target.value)} onBlur={e=>setName(e.target.value.trim())} />
        </label>
        <label className="field">
          <strong>服務/商品介紹</strong>
          <textarea value={srv_desc}
            onChange={e=>setDescription(e.target.value)}
            onBlur={e=>setDescription(e.target.value.trim())} >
          </textarea>
        </label>
        <label className="field">
          <strong>價錢</strong>
          <input value={price} type="number"
            onChange={e=>setPrice(parseFloat(e.target.value))}/>
        </label>
      </div>
      <div className="action-panel">
        <span className="dummy"></span>
        { !service
          ? <button className="green btn" onClick={submit}>新增</button>
          : <button className="blue btn"  onClick={submit}>更新</button>
        }
      </div>
    </div>
  );
}
//===============================================================================================================

const UnitServiceTable = ({items, showEditModal}) =>
{
  return (
    <table className="data-table full-width">
      <colgroup>
        <col width="20px"  id="col-unit-srv-sel"/>
        <col width="60px"  id="col-unit-srv-id"/>
        <col width="100px" id="col-unit-srv-grp"/>
        <col width="280px" id="col-unit-srv-name"/>
        <col width="100px" id="col-unit-srv-price"/>
        <col width="auto"  id="col-unit-srv-desc"/>
        <col width="120px" id="col-unit-srv-create-date"/>
        <col width="120px" id="col-unit-srv-mod-date"/>
        <col width="120px" id="col-unit-srv-mod-by"/>
        <col width="36px"  id="col-unit-srv-btn-grp"/>
      </colgroup>
      <thead>
        <tr>
          <th className="col-unit-srv-sel"></th>
          <th className="col-unit-srv-code">編號</th>
          <th className="col-unit-srv-grp">分類</th>
          <th className="col-unit-srv-name">名稱</th>
          <th className="col-unit-srv-price">單價</th>
          <th className="col-unit-srv-desc">描述</th>
          <th className="col-unit-srv-create-date">建立日期</th>
          <th className="col-unit-srv-mod-date">修訂日期</th>
          <th className="col-unit-srv-mod-by">修訂人</th>
          <th className="col-unit-srv-btn-grp"></th>
        </tr>
      </thead>
      <tbody>
        { items.map(s => <UnitServiceRow key={s.id} service={s}
            showEditModal={showEditModal} /> )}
      </tbody>
    </table>
  );
}

//===============================================================================================================


const UnitServiceView = () =>
{
  const [data,       setData      ] = useState(null);
  const [items,      setItems     ] = useState([]);
  const [filter,     setFilter    ] = useState({ name: ''});
  const [modal,      setModal     ] = useState(null);
  const [modalTitle, setModalTitle] = useState('');

  const showAddModal = () =>
  {
    let modal = <UnitServiceModal />;
    setModal(modal);
    setModalTitle('新增服務/商品');
  }
  const showEditModal = (origin) =>
  {
    let modal = <UnitServiceModal service={origin}/>;
    setModal(modal);
    setModalTitle('修改服務/商品');
  }
  const closeModal = () => setModal(null);

  const refreshFilter = (apiData) =>
  {
    let _items = apiData || data;
    if (filter.name) {
      let fname = filter.name.toLowerCase();
      _items = _items.filter(x => -1<x.srv_name.toLowerCase().indexOf(fname));
    }
    setItems(_items);
  }

  //-----------------------------------------------------------------
  // -- init
  useEffect(() => {
    API.getUnitServices().then(data => {
      setData(data);
      refreshFilter(data);
    });
  }, []);

  useEffect(() => {
    refreshFilter();
  }, [filter]);

  // render
  return (
    <>
      <h2>
        <span className="main-title">基本資料</span> - <span className="sub-title">服務及商品</span>
      </h2>
      <div className="search-bar box">
        <h4 className="box-head">
          <span>搜尋</span>
          <div className="button-group">
            <Protected allow={['ADMIN']}>
              <button className="btn small green" type="button"
                      onClick={ showAddModal }>
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </Protected>
          </div>
        </h4>
        <div className="box-body">
          <label className="search-field">
            <span>名稱</span>
            <input id="f-name" value={ filter.name }
                    onChange={ e=>setFilter({...filter, name: e.target.value}) }/>
          </label>
        </div>
      </div>
      <div className="unit-service">
        { !data
          ?<Loading />
          :(!items?.length
            ? <NoData />
            : <UnitServiceTable items={items} showEditModal={showEditModal} />
           )
        }
      </div>
      <ModalScreen title={modalTitle} show={!!modal} onClose={closeModal}>
        { modal}
      </ModalScreen>
    </>
  );

}

export default UnitServiceView;